// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__39ch1","footer":"ModalCreateQualiphyProcedure_footer__1Da-A","additionData":"ModalCreateQualiphyProcedure_additionData__1L7ls"};